<div class="container-example-linea-avance-govco" style="margin: initial!important;">
  <div class="linea-avance-govco h-linea-avance-govco" id="lineaAvance1">
    <div class="progress">
      <div class="progress-bar" role="progressbar" [ngStyle]="{width: currentStep+'%'}" aria-valuenow="50"
           aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <div class="items-header-linea-avance-govco" [ngClass]="{'active-linea-avance-govco': step === 1}">
      <div class="header-linea-avance-govco">
        <div class="indicator-linea-avance-govco" data-la-target="#itemLineaAvance11" percentage="15">1</div>
        <span class="title-linea-avance-govco">Inicio</span>
      </div>
      <div class="header-linea-avance-govco choice-option" [ngClass]="{'active-linea-avance-govco': step === 2}"
           >
        <div class="indicator-linea-avance-govco" data-la-target="#itemLineaAvance12" percentage="50">2</div>
        <span class="title-linea-avance-govco">Hago mi solicitud</span>
      </div>
      <div class="header-linea-avance-govco" [ngClass]="{'active-linea-avance-govco': step === 3}">
        <div class="indicator-linea-avance-govco" data-la-target="#itemLineaAvance13" percentage="80">3</div>
        <span class="title-linea-avance-govco">Procesan mi solicitud</span>
      </div>
      <div class="header-linea-avance-govco choice-option" [ngClass]="{'active-linea-avance-govco': step === 4}"
           >
        <div class="indicator-linea-avance-govco" data-la-target="#itemLineaAvance14" percentage="100">4</div>
        <span class="title-linea-avance-govco">Respuesta</span>
      </div>
    </div>
  </div>
</div>
